export default __webpack_public_path__ + "static/media/2_hole_button.3b514a5e.jpg";